<div class="w-full">
    <div class="grid grid-cols-6 gap-6" [ngClass]="isDisabled ? 'bg-gray-100': 'bg-white'">

        <!-- Frequency -->
        <div class="col-span-3 bg-inherit">
            <label for="customer_home_number" class="block text-base font-medium text-gray-700">{{"recurrence.label.choose_frequecy" | translate}}
            </label>
            <mat-select [(ngModel)]="option.frequency" (ngModelChange)="frequencyChange()" class="bg-inherit border-gray-300 rounded-lg w-full mt-1 mb-1 border p-2.5">
            <mat-option value="DAILY"> {{"text.daily" | translate}}</mat-option>
            <mat-option value="WEEKLY"> {{ "recurrence.frequency.options.weekly" | translate}} </mat-option>
            <mat-option value="MONTHLY"> {{ "recurrence.frequency.options.monthly" | translate}} </mat-option>
            <mat-option value="YEARLY"> {{ "recurrence.frequency.options.yearly" | translate}} </mat-option>
            </mat-select>
        </div>

        <!-- Repeat Every -->
        <div class="col-span-3 bg-inherit">
            <label for="repeatEvery" class="block text-base font-medium text-gray-700">{{"recurrence.label.repeat_every" | translate}}
            </label>
            <div class="flex">
                <input 
                    type="number" 
                    name="repeatEvery" 
                    [(ngModel)]="option.repeat"
                    (ngModelChange)="repeatChanged()"
                    id="repeatEvery" 
                    class="mt-1 w-3/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base"
                    placeholder="{{'text.enter_number' | translate}}"
                > 
                <span class="inline-flex items-center mt-1 px-3 pt-0.5 text-base text-gray-900 bg-gray-200 border border-l-0 border-gray-300 rounded-r-md">
                    {{repeatInputGroup[option?.frequency]}}(s)
                </span>
            </div>     
        </div>
        <!-- Weekly Rule -->
        <div class="col-span-6 bg-inherit" *ngIf="this.option?.frequency === 'WEEKLY'">
            <label for="weekly" class="block text-base font-medium text-gray-700">{{"recurrence.weekly.label" | translate}}
            </label>
            <div class="flex mt-2 space-x-4">
                <span
                    (click)="selectDay(key)"
                    *ngFor="let key of getweeks()" 
                    class="text-xl leading-8 font-medium px-3 py-0.5 rounded border cursor-pointer"
                    [ngClass]="{
                                'bg-primary-100 text-primary-700 border-primary-400': masterWeek[key]['isSelected'],
                                'bg-inherit text-gray-500 border-gray-400': !masterWeek[key]['isSelected']
                               }"
                    >{{key[0]}}</span>
                <!-- <span class=" text-xl leading-8 font-medium px-3 py-0.5 rounded border ">S</span> -->
            </div>     
        </div>

        <!-- Monthly Rule -->
        <div class="col-span-6 bg-inherit" *ngIf="this.option?.frequency === 'MONTHLY'">
            <ul class="text-base font-semibold text-center text-gray-500 divide-x rounded-lg sm:flex">
                <li class="w-full cursor-pointer" (click)="setCurrentMonthlyRule('MONTH')">
                    <a 
                        class="inline-block w-full p-4 bg-gray-100 rounded-l-lg" 
                        aria-current="page"
                        [ngClass]="{
                                'text-primary-700 bg-primary-100': currentMonthlyRule === 'MONTH',
                                'hover:text-primary-700 hover:bg-primary-50': currentMonthlyRule !=='MONTH'
                                }"
                    >
                    {{"recurrence.header.day_of_month" | translate}}</a>
                </li>
                
                <li class="w-full cursor-pointer" (click)="setCurrentMonthlyRule('WEEK')">
                    <a 
                        class="inline-block w-full p-4 bg-gray-100 rounded-r-lg"
                        [ngClass]="{
                            'text-primary-700 bg-primary-100': currentMonthlyRule === 'WEEK',
                            'hover:text-primary-700 hover:bg-primary-50': currentMonthlyRule !=='WEEK'
                            }"
                    >{{"recurrence.header.day_of_week" | translate}}</a>
                </li>
            </ul>
            <div class="flex mt-2 space-x-4 space-y-4 flex-wrap bg-inherit" *ngIf="currentMonthlyRule === 'MONTH'">
                <span
                    (click)="selectMonthDay(key)"
                    *ngFor="let key of getMonthDays(); let i = index" 
                    class="text-xl leading-8 flex w-12 justify-center font-medium px-3 py-0.5 rounded border cursor-pointer"
                    [ngClass]="{
                                'ml-4 mt-4': i === 0,
                                'bg-primary-100 text-primary-700 border-primary-400': masterDays[key]['isSelected'],
                                'bg-inherit text-gray-500 border-gray-400': !masterDays[key]['isSelected']
                               }"
                    >{{key}}</span>
            </div>  

            <div class="px-6 bg-inherit" *ngIf="currentMonthlyRule === 'WEEK'">
                <div 
                    *ngFor="let key of getMonthWeek(); let i = index" 
                    class="flex mt-2 space-x-12 items-center flex-wrap bg-inherit">
                    <div class="w-8">
                        {{key}}
                    </div>
                    <div class="flex mt-2 space-x-4 bg-inherit">
                        <span
                            (click)="selectMonthWeek(key, day)"
                            *ngFor="let day of getParsedWeek(masterWeekDays[key]['weeks'])" 
                            class="text-xl leading-8 font-medium px-3 py-0.5 rounded border cursor-pointer"
                            [ngClass]="{
                                        'bg-primary-100 text-primary-700 border-primary-400':  masterWeekDays[key]['weeks'][day]['isSelected'],
                                        'bg-inherit text-gray-500 border-gray-400': !masterWeekDays[key]['weeks'][day]['isSelected']
                                       }"
                            >{{day[0]}}</span>
                    </div>  
                </div>
            </div>
        </div>

        <!-- Yearly Rule -->
        <div class="col-span-6 bg-inherit" *ngIf="this.option?.frequency === 'YEARLY'">
            <label for="yearly_month" class="block text-base font-medium text-gray-700">{{"reports.scheduled_reports.editDetailsDrawer.report_data_duration.months" | translate}}
            </label>
            <div class="flex space-y-4 flex-wrap bg-inherit">
                <span
                    (click)="selectMonth(key)"
                    *ngFor="let key of getMonths(); let i = index" 
                    class="text-lg leading-8 font-medium px-3 py-0.5 rounded border cursor-pointer mr-4"
                    [ngClass]="{
                                'mt-4': i === 0,
                                'bg-primary-100 text-primary-700 border-primary-400': masterMonth[key]['isSelected'],
                                'bg-inherit text-gray-500 border-gray-400': !masterMonth[key]['isSelected']
                               }"
                    >{{key}}</span>
                <!-- <span class=" text-xl leading-8 font-medium px-3 py-0.5 rounded border ">S</span> -->
            </div>  

            <label for="yearly_day" class="block text-base font-medium text-gray-700 mt-6">{{"recurrence.header.day_of_month" | translate}}</label>

            <div class="flex space-y-4 flex-wrap bg-inherit">
                <span
                    (click)="selectYearDay(key)"
                    *ngFor="let key of getMonthDays(); let i = index" 
                    class="text-xl leading-8 flex w-12 justify-center font-medium px-3 py-0.5 rounded border cursor-pointer mr-4"
                    [ngClass]="{
                                'mt-4': i === 0,
                                'bg-primary-100 text-primary-700 border-primary-400': masterDays[key]['isSelected'],
                                'bg-inherit text-gray-500 border-gray-400': !masterDays[key]['isSelected']
                                }"
                    >{{key}}</span>
            </div>
        </div>
    </div>
    <!-- RRule Display -->
    <p *ngIf="rruleText" class="mt-4 text-base font-semibold capitalize">{{rruleText}}</p>
</div>